<template>
  <div class="message-queue-confirmation">
    <div class="message-queue-confirmation-tip">
      <span v-for="(part, index) in formattedTips" :key="index">
      <span v-if="part.isNumber" class="message-queue-confirmation-tip-number">{{ part.content }}</span>
      <span v-else>{{ part.content }}</span>
    </span>
    </div>
    <div v-if="!props.payload.status && !isConfirmed" class="message-queue-confirmation-button" @click="sendMessage">
      {{ TUITranslateService.t('AIDesk.确认转人工') }}
    </div>
  </div>
</template>

<script lang="ts">
import { TUITranslateService } from '../../../../../../@aidesk/uikit-engine';
import { CUSTOM_MESSAGE_SRC } from '../../../../../../constant';
import vue from '../../../../../../adapter-vue';
const { ref, computed } = vue;
import { customerServicePayloadType } from '../../../../../../interface';

interface Props {
  payload: customerServicePayloadType;
}

export default {
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({}),
    },
  },
  emits:['sendMessage'],
  setup(props: Props, {emit}) {
    const isConfirmed = ref<boolean>(false);
    const { transferConfirmTips, waitingQueueLength, sessionId, skillGroupId, transferConfirmId } = props.payload.content;
    const formattedTips = computed(() => {
      if (!transferConfirmTips) return [];
      
      const parts = transferConfirmTips.split('${WaitNo}');
      const result: { content: any; isNumber: boolean; }[] = [];
      
      parts.forEach((part, index) => {
        if (part) {
          result.push({ content: part, isNumber: false });
        }
        if (index < parts.length - 1) {
          result.push({ content: waitingQueueLength, isNumber: true });
        }
      });
      
      return result;
    });

    const sendMessage = () => {
      let data = {
        data: JSON.stringify({
          src: CUSTOM_MESSAGE_SRC.QUEUE_CONFIRMATION,
          content: {
            sessionId: sessionId,
            skillGroupId: skillGroupId,
            transferConfirmId: transferConfirmId,
          }
        })
      };
      emit('sendMessage', data);
      isConfirmed.value = true;
    }

    return {
      props,
      formattedTips,
      isConfirmed,
      sendMessage,
      TUITranslateService
    };
  },
};
</script>
<style lang="scss" scoped>
.message-queue-confirmation-tip-number {
  color: #006AF6;
}
.message-queue-confirmation-button {
  color: #006AF6;
  cursor: pointer;
  margin-top: 12px;
  border: 1px solid #adcfff;
  width: fit-content;
  padding: 0px 16px;
  height: 32px;
  border-radius: 999px;
  line-height: 32px;
  background-color: #fff;
}
</style>
